/* globals document, $, window, location, config */

$(document).ready(() => {
    $(window).on('message', async (e) => {
        const iframeMessage = (e && e.originalEvent && e.originalEvent.data && typeof e.originalEvent.data === 'string') ? e.originalEvent.data : '';

        if (iframeMessage === 'close' && $('#iframe-login')) {
            $('#iframe-login').remove();

            $.post('/sal/hide-login');
        } else if (iframeMessage === 'success' && $('#iframe-login')) {

            $('#iframe-login').remove();

            $.post('/sal/hide-login', () => {
                location.reload();
            });
        } else if (iframeMessage && iframeMessage.startsWith('URL:')) {
            // Used by the signup/register and SSO login option in the iframed DW-login screen
            const sentUrl = iframeMessage.split('URL:')[1];

            window.location.href = sentUrl;
        }
    });
});